const shallowComparison = <T>(a: T, b: T) => a !== b;
export default shallowComparison;
